"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePart = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const _part_includes_1 = require("../_part_includes");
const console_1 = require("@rws-framework/console");
//@ts-ignore                
let rwsTemplate = T.html `<div class="form-group has-float-label form-group rounded">
    ${(0, fast_element_1.when)(x => x.label, T.html `<label htmlFor="${x => x.name}" class="" part="label">${x => x.label.t()}</label>`)}    
    <input 
        ${(0, fast_element_1.ref)('dateField')}
        part="input"
        type="date" 
        @change="${(x, c) => x.handleChange(c.event)}" 
        name="${x => x.name}" 
        class="form-control" 
        :value="${x => x.formatDateForInput(x.value)}"
        min="${x => x.min ? x.min : ''}"
        max="${x => x.max ? x.max : ''}"
        ?required="${x => x.isRequired}"
        placeholder="${x => x.placeholder ? x.placeholder.t() : ''}"
        />
</div>
`;
require("./styles/layout.scss");
const styles = T.css `.form-group.rounded input[type=date].form-control {
  border: 1px solid var(--brand-border, #e4e7ec);
  border-radius: 8px;
  color: var(--ink, #2f2f3a);
  background: #fff;
  font-size: 0.95rem;
  padding: 0.55rem 0.75rem;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.form-group.rounded input[type=date].form-control:focus {
  border-color: var(--brand, #17b4a6);
  box-shadow: 0 0 0 0.2rem rgba(23, 180, 166, 0.2);
  outline: none;
}`;
const shadowOptions = { "mode": "open" };
let DatePart = class DatePart extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.value = '';
        this.ignored = 'false';
        this.dontEmit = false;
        this.handleChange = _part_includes_1.handlePartChange.bind(this);
    }
    valueChanged(oldValue, newValue) {
        if (newValue) {
            // Convert datetime string to date-only format (YYYY-MM-DD)
            const formattedValue = this.formatDateForInput(newValue);
            // Update the input field if it exists and value is different
            if (this.dateField && this.dateField.value !== formattedValue) {
                this.dateField.value = formattedValue;
            }
        }
    }
    /**
     * Format date value for HTML date input (YYYY-MM-DD)
     */
    formatDateForInput(value) {
        if (!value)
            return '';
        try {
            // Use DateUtils to parse and format the date
            const dateUtils = console_1.DateUtils.create(value);
            // Return date in YYYY-MM-DD format using DateUtils
            return dateUtils.formatDate('yyyy-MM-dd');
        }
        catch (error) {
            console.warn('DatePart: Invalid date value:', value, error);
            return '';
        }
    }
    requiredChanged(oldValue, newValue) {
        this.required = newValue;
        this.isRequired = this.required === 'true';
    }
    getElement() {
        return this.dateField;
    }
    connectedCallback() {
        super.connectedCallback();
        console.log('DatePart connected with initial value:', this.value);
        // Set initial value to the input field after template is rendered
        if (this.value) {
            const formattedValue = this.formatDateForInput(this.value);
            // Use requestAnimationFrame to ensure the input field is rendered
            requestAnimationFrame(() => {
                if (this.dateField && formattedValue) {
                    this.dateField.value = formattedValue;
                    console.log('DatePart: Set formatted value to input using DateUtils:', formattedValue);
                }
            });
        }
    }
    reset() {
        this.$('input').value = '';
        this.value = '';
    }
};
exports.DatePart = DatePart;
DatePart.PART_TYPE = 'date';
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], DatePart.prototype, "label", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], DatePart.prototype, "name", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], DatePart.prototype, "value", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], DatePart.prototype, "required", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], DatePart.prototype, "placeholder", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], DatePart.prototype, "ignored", void 0);
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], DatePart.prototype, "dontEmit", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], DatePart.prototype, "min", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], DatePart.prototype, "max", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], DatePart.prototype, "isRequired", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Function)
], DatePart.prototype, "onChange", void 0);
exports.DatePart = DatePart = __decorate([
    (0, client_1.RWSView)('part-date', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], DatePart);
DatePart.defineComponent();
